import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./index.css";
import SvgIcon from "@/components/SvgIcon.vue";
import ModalDialog from "@/components/ModalDialog.vue";
import ErrorAlert from '@/components/ErrorAlert.vue';
import { loadUser, loadGate } from '@/store/store';
import { Icon } from 'leaflet';
import i18n from '@/i18n';

// Fix for leaflet marker image not displayed
type D = Icon.Default & {
    _getIconUrl?: string;
}

delete (Icon.Default.prototype as D)._getIconUrl  
// eslint-disable-next-line  
Icon.Default.mergeOptions({  
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),  
  iconUrl: require('leaflet/dist/images/marker-icon.png'),  
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')  
});

loadUser();
loadGate();

const app = createApp(App);
app.component("SvgIcon", SvgIcon);
app.component("ModalDialog", ModalDialog)
app.component("ErrorAlert", ErrorAlert)
app.use(router).use(i18n).mount("#app");
